<template>
    <DnIcon
        :has-stroke="true"
        :has-fill="false"
    >
        <template
            v-for="name of Object.keys($slots)"
            v-slot:[name]="scope"
        >
            <slot
                :name="name"
                v-bind="scope"
            />
        </template>
    </DnIcon>
</template>

<script setup>
import DnIcon from '@digitalnatives/icon';
</script>

<style lang="less">
/** Override for items with explicit fill on svg but without the has-fill modifier -- give priority to what the SVG says */
.dn-icon > svg:not([fill='none']) {
    g, path, polygon, svg {
        fill: currentColor !important; /* stylelint-disable-line declaration-no-important */
    }
}

/** Override for items with explicit no stroke on svg but with has-stoke modifier as well -- give priority to what the SVG says */
.dn-icon--has-stroke > svg[stroke='none'] {
    g, path, polygon, svg {
        stroke: none !important; /* stylelint-disable-line declaration-no-important */
    }
}
</style>